// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b6ece5f6","453":"c58d9bc0","732":"90cc9e74","977":"313183a7"}[chunkId] + ".chunk.js";
};